export enum OverTimeOptions {
  AllFromActivePart = 1,
  SelectedDays = 2,
  AboveLumpsum = 3,
  ClearSelectedDays = 4,
  ClearAll = 5,
}

export const getOvertimeOptionName = (type: number) => {
  let path = '-'

  switch (type) {
    case 1:
      path = 'timesheet.move-for-all-days'
      break
    case 2:
      path = 'timesheet.move-for-selected-days'
      break
    case 3:
      path = 'timesheet.move-for-lump'
      break
    case 4:
      path = 'timesheet.rollback-for-selected-days'
      break
    case 5:
      path = 'timesheet.rollback-for-all-days'
      break
  }

  return path
}